import React, { useEffect, useRef, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
const samplePurchases = [{
  name: 'Michael R.',
  location: 'Austin, Texas'
}, {
  name: 'David L.',
  location: 'Phoenix, Arizona'
}, {
  name: 'James T.',
  location: 'Tampa, Florida'
}, {
  name: 'Robert K.',
  location: 'Denver, Colorado'
}, {
  name: 'Carlos M.',
  location: 'San Diego, California'
}, {
  name: 'Brandon S.',
  location: 'Charlotte, North Carolina'
}, {
  name: 'Kevin P.',
  location: 'Columbus, Ohio'
}, {
  name: 'Anthony G.',
  location: 'Las Vegas, Nevada'
}];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(samplePurchases[0]);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(samplePurchases[Math.floor(Math.random() * samplePurchases.length)]);
      setVisible(true);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);
  if (!visible) return null;
  return <aside className="fixed bottom-3 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[260px] animate-slide-in" aria-live="polite" data-id="element-150" data-mp="n7ddguaqjqiy">
      <div className="relative overflow-hidden rounded-xl border-2 border-brand-orange bg-white p-3 pr-8 shadow-2xl ring-2 ring-brand-amber/70" data-id="element-151" data-mp="iaekif2t5pmc">
        <div className="absolute inset-x-0 top-0 h-1 bg-brand-amber" data-id="element-152" data-mp="s56frc8x40dy" />
        <button type="button" onClick={() => setVisible(false)} className="absolute right-1.5 top-1.5 rounded p-0.5 text-brand-muted transition-colors hover:text-brand-ink" aria-label="Close purchase notification" data-id="element-153" data-mp="28k7r4ssoyejg">
          <XIcon className="h-3.5 w-3.5" data-id="element-154" data-mp="2apcr8yu90zhe" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-155" data-mp="2aqxkml4tucdo">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-brand-orange/60 bg-brand-amber/20" data-id="element-156" data-mp="2fmmqt7bcqriy">
            <ShoppingBagIcon className="h-4 w-4 text-brand-orange" data-id="element-157" data-mp="2kkoa9tcowsuy" />
          </div>
          <div className="min-w-0 leading-tight" data-id="element-158" data-mp="2pl2gr6yn7uqv">
            <p className="font-display text-sm font-extrabold text-brand-ink" data-id="element-159" data-mp="1rylkm51nbn6p">{current.name}</p>
            <p className="text-[11px] font-semibold text-brand-muted" data-id="element-160" data-mp="1wwn3aov5tkhn">from {current.location}</p>
            <p className="mt-0.5 text-xs font-bold text-brand-orange" data-id="element-161" data-mp="21vpy7ghfeabw">
              just purchased {PRODUCT_NAME}
            </p>
          </div>
        </div>
      </div>
    </aside>;
}